module.exports = __webpack_public_path__ + "img/contact17.a9671d3d.png";